<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLImgAttributes } from 'svelte/elements';
	import { tv } from '../tv';

	export const avatarImageVariants = tv({
		base: 'absolute size-full rounded-[inherit] object-cover'
	});

	export type AvatarImageProps = Omit<HTMLImgAttributes, 'class' | 'children'> & {
		class?: ClassValue;
		fallback?: Snippet;
		ref?: HTMLImageElement | null;
	};
</script>

<script lang="ts">
	let {
		class: className,
		fallback,
		onerror,
		onload,
		ref = $bindable(null),
		src,
		...rest
	}: AvatarImageProps = $props();

	let loadedSrc = $state<string>();
	let failedSrc = $state<string>();
	const loaded = $derived(!!src && loadedSrc === src);
	const failed = $derived(!!src && failedSrc === src);
</script>

{#if !src || failed}
	{@render fallback?.()}
{:else if !loaded}
	<span class="bg-surface-variant-container absolute size-full rounded-[inherit]"></span>
{/if}
{#if src && !failed}
	{#key src}
		<img
			bind:this={ref}
			class={[avatarImageVariants(), className]}
			{src}
			onload={(event) => {
				loadedSrc = src;
				onload?.(event);
			}}
			onerror={(event) => {
				failedSrc = src;
				onerror?.(event);
			}}
			{...rest}
		/>
	{/key}
{/if}
